import { useEffect } from 'react';
import { Form } from 'antd';
import { filterObject } from 'shared/helpers/utils/objects';
import type { TableFilterField } from './types';

const isNonEmptyValue = (_key: string, value: unknown) => value !== undefined && value !== '';

interface UseTableFilterFormParams {
  fieldsValue?: Record<string, any>;
  onSubmit: (values: Record<string, any>) => void;
  onClose: () => void;
  onLoadOptions?: (fieldName: string) => void;
}

export const useTableFilterForm = ({
  fieldsValue,
  onSubmit,
  onClose,
  onLoadOptions,
}: UseTableFilterFormParams) => {
  const [form] = Form.useForm();

  const onFormSubmit = () => {
    form.validateFields().then((values) => {
      const filteredValues = filterObject(values, isNonEmptyValue);
      onSubmit(filteredValues);
      onClose();
    });
  };

  const onReset = () => {
    form.resetFields();
    onFormSubmit();
  };

  const onSelectDropdownVisible = (field: TableFilterField, open: boolean) => {
    if (!open || !field.isLoadableOptions || !onLoadOptions || field.options?.length) {
      return;
    }
    onLoadOptions(field.name);
  };

  useEffect(() => {
    if (fieldsValue) {
      form.setFieldsValue(fieldsValue);
    }
  }, [fieldsValue]);

  return {
    state: {
      form,
    },
    methods: {
      onFormSubmit,
      onReset,
      onSelectDropdownVisible,
    },
  };
};
